// Copyright (C) 2017-2022 Smart code 203358507

const ModalsContainerProvider = require('./ModalsContainerProvider');
const useModalsContainer = require('./useModalsContainer');

module.exports = {
    ModalsContainerProvider,
    useModalsContainer
};
